import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=796ac803&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=ts&"
export * from "./preview.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/front.css?vue&type=style&index=0&id=796ac803&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ac803",
  null
  
)

export default component.exports